import type { CSSProperties } from 'react';
import { neonVar } from '@/utils/neon-utils';

export const EMPTY_STATE_ILLUSTRATION_STYLE: CSSProperties = {
  width: 236,
  height: 157,
  opacity: 1,
};

export const EMPTY_STATE_TITLE_STYLE: CSSProperties = {
  fontFamily: neonVar('font-family', 'Roboto, Arial, Helvetica, sans-serif'),
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '24px',
  lineHeight: '36px',
  letterSpacing: 0,
  color: neonVar('color-black-400', '#333333'),
  margin: 0,
};

export const EMPTY_STATE_BODY_STYLE: CSSProperties = {
  fontFamily: neonVar('font-family', 'Roboto, Arial, Helvetica, sans-serif'),
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: 0,
  color: neonVar('color-black-400', '#333333'),
};

export const EMPTY_STATE_CARD_STYLE: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
};
